// we have these same functions defined here, but for some reasons i can't import in the file
// im just including as a normal script. not sure why. TODO - figure it out.
//
// import { normalizePhoneNumber, formatPhoneNumber } from 'shared/utils/phone_numbers.js'

const normalizePhoneNumber = (value) => {
  if (!value) {
    return "";
  }

  return value.replace(/[\D]/g, ''). // only numbers
    slice(0, 10); // only 10 of them
};

const formatPhoneNumber = (value) => {
  if (!value) {
    return "";
  }

  if (value.length <= 3) {
    return value;
  }

  if (value.length <= 6) {
    return `(${value.slice(0, 3)}) ${value.slice(3)}`;
  }

  return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
};

$(document).on('turbo:load', function() {
  $("[data-behavior=format-phone-number]").val(function(index, value) {
    return formatPhoneNumber(normalizePhoneNumber(value));
  });
});

$(document).on("keyup change", "[data-behavior=format-phone-number]", function(event) {
  $(this).val(function(index, value) {
    return formatPhoneNumber(normalizePhoneNumber(value));
  });
});
